import { Hero } from "@/components/Hero";
import { Manifesto } from "@/components/Manifesto";
import { Bivio } from "@/components/Bivio";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Manifesto />
      <Bivio />
    </main>
  );
}
